import { render, staticRenderFns } from "./ModalShowPublishSuccess.vue?vue&type=template&id=1176d4b6&scoped=true"
import script from "./ModalShowPublishSuccess.vue?vue&type=script&lang=js"
export * from "./ModalShowPublishSuccess.vue?vue&type=script&lang=js"
import style0 from "./ModalShowPublishSuccess.vue?vue&type=style&index=0&id=1176d4b6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1176d4b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1176d4b6')) {
      api.createRecord('1176d4b6', component.options)
    } else {
      api.reload('1176d4b6', component.options)
    }
    module.hot.accept("./ModalShowPublishSuccess.vue?vue&type=template&id=1176d4b6&scoped=true", function () {
      api.rerender('1176d4b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalShowPublishSuccess.vue"
export default component.exports